(function($) {
  'use strict';

  const addOns = {
    dom: function() {
      this.$addons = $('[data-addons]');
      this.$carousel = $('[data-addons-splide]');
    },

    slideSlider: function() {
      if (typeof addOns.$addons == 'undefined' || !addOns.$addons.length) {
        return;
      }

      addOns.$addons.each(function() {
        const $this = $(this);
        $this.slick({
          infinite: false,
          arrows: false,
          dots: false,
          slidesToShow: 4,
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: jcms.breakpoints.xlarge,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: jcms.breakpoints.medium,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: jcms.breakpoints.fluid,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: jcms.breakpoints.fluid_small,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      });
    },

    splideSlider: function() {
      this.$carousel.each(function(index, element) {
        const splide = new Splide(element, {
          type: 'slide',
          arrows: false,
          pagination: false,
          autoWidth: true,
          perMove: 1,
          padding: 'var(--padding)'
        });
        splide.mount();
      });
    },

    ready: function() {
      this.dom();
      // this.slideSlider();
      this.splideSlider();
    }
  };

  $(function() { addOns.ready(); });

})(jQuery);
